import React, { useState } from 'react';
import { FiHelpCircle, FiSearch, FiX } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import SearchBar from './SearchBar';
import { getOrganizationFromPath } from '../utilities/organizationUtils';

const Header = ({ onFileSelect, onSearch, folderStructure }) => {
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const location = useLocation();
  const currentOrg = getOrganizationFromPath(location.pathname);
  
  // Always link to main page, not org frontpage
  const homeLink = '/';

  const toggleMobileSearch = () => {
    setShowMobileSearch(!showMobileSearch);
  };

  return (
    <header className="oao-header bg-gray-100 shadow-md relative z-10">
      <div className="px-6 py-4">
        {/* Add padding-left on mobile to prevent overlap with burger menu */}
        <div className="flex justify-between items-center relative lg:pl-0 pl-12">
          <div className="flex items-center gap-3">
            <Link to={homeLink} onClick={() => onFileSelect(null)}>
              <img
                src="https://www.oao.dk/_assets/ebc501cba2eeadc80bc01afb741736d1/Images/Logo/logo-claim.svg"
                alt="OAO logo"
                className="h-[60px] sm:h-[90px] object-contain cursor-pointer"
              />
            </Link>
            <h1 className="hidden sm:block text-2xl tracking-tight text-gray-800 lg:text-3xl leading-tight relative top-[2px]">
              Faglig Håndbog
            </h1>
          </div>

          {/* Search and Help aligned to the right */}
          <div className="flex items-center gap-2 relative top-[4px]">
            {/* Desktop SearchBar - hidden on mobile */}
            <div className="hidden md:block">
              <SearchBar 
                onFileSelect={onFileSelect} 
                onSearch={onSearch} 
                folderStructure={folderStructure}
              />
            </div>

            {/* Mobile Search Button - shows on mobile, hidden on desktop */}
            <button
              onClick={toggleMobileSearch}
              className="md:hidden p-2 rounded-md hover:bg-gray-100"
              aria-label="Search"
            >
              {showMobileSearch ? (
                <FiX className="h-6 w-6 text-gray-600" />
              ) : (
                <FiSearch className="h-6 w-6 text-gray-600" />
              )}
            </button>

            {/* Help button with tooltip */}
            <div
              className="text-gray-600"
              aria-label="Hjælp"
              title="Søg blandt samtlige filer i den Faglige Håndbog"
            >
              <FiHelpCircle className="h-6 w-6" />
            </div>
          </div>
        </div>

        {/* Mobile Search Expansion - Below main header */}
        {showMobileSearch && (
          <div className="md:hidden mt-4 pb-2">
            <SearchBar 
              onFileSelect={(file) => {
                onFileSelect(file);
                setShowMobileSearch(false);
              }} 
              onSearch={(results) => {
                onSearch(results);
                setShowMobileSearch(false);
              }} 
              folderStructure={folderStructure}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;